<template>
  <div v-resize="onResize">
    <v-menu
      rounded="xl"
      :close-on-content-click="false"
      transition="slide-y-transition"
      bottom
      left
      offset-y
      nudge-bottom="8"
      nudge-right="10"
      v-model="isOpen"
      :key="keyUpdate"
    >
      <template v-slot:activator="{ on }">
        <div class="account-link" v-on="on">
          <div class="account-text">
            <!-- <v-icon class="mr-0" color="primary">mdi-chevron-down</v-icon> -->
            Moje konto
          </div>
          <div aria-label="Konto" class="btn-account">
            {{ displayNameinitial }}
          </div>
        </div>
      </template>
      <v-list class="contest-menu-list">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ displayName }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ user && user.user_name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item
          :to="{ name: 'AccountNotification' }"
          @click="isOpen = false"
        >
          <v-list-item-icon class="my-3 mr-6">
            <v-icon>mdi-bell-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Powiadomienia</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="{ name: 'AccountUserProfile' }"
          @click="isOpen = false"
        >
          <v-list-item-icon class="my-3 mr-6">
            <v-icon>mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Dane&nbsp;użytkownika</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click.native="logout" link @click="isOpen = false">
          <v-list-item-icon class="my-3 mr-6">
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'Wyloguj'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- <router-link
    class="account-link"
    :to="{ name: 'AccountUserProfile' }"
    :title="displayName"
  >
    <div class="account-text">Moje konto</div>
    <div aria-label="Konto" class="btn-account">
      {{ displayNameinitial }}
    </div>
  </router-link> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { clearFiltersStorage } from "@/util/auth-util";
import { debounce } from "lodash-es";

export default {
  name: "LibHeaderAccount",
  data() {
    return {
      isOpen: false,
      keyUpdate: 1
    };
  },
  computed: {
    ...mapGetters({
      displayName: "auth/getDisplayName",
      displayNameinitial: "auth/getDisplayNameinitials",
      user: "auth/getUser",
      userId: "auth/getUserId"
    }),
    isClosedMenu() {
      return this.$store.state.layout.isClosedMenu;
    }
  },
  methods: {
    onResize: debounce(function() {
      this.recalculateMenus();
    }, 800),
    recalculateMenus() {
      if (this.isOpen) return;
      this.$nextTick(() => {
        this.keyUpdate = this.keyUpdate + 1;
      });
    },
    logout() {
      clearFiltersStorage(this.userId);
      const hasNIdSId = this.$store.getters["auth/hasNIdSId"];
      if (hasNIdSId) {
        this.$store.dispatch("auth/wklogout");
      } else {
        this.$store.dispatch("auth/logout");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.account-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  cursor: pointer;
  &:hover .account-text {
    text-decoration: underline;
  }
}
.account-text {
  color: var(--c-primary);
  font-size: 14px;
}

.btn-account {
  width: 32px;
  height: 32px;
  display: block;
  background: var(--c-primary);
  color: #fff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border-radius: 50%;
}
</style>
